import { Invoice } from "../../../services/Invoices/InvoiceService/InvoiceService";
import { IInvoiceList } from "./types";

export const mapInvoiceList = (data: Invoice[]): IInvoiceList[] => {
	return data.map((item, index) => ({
		key: `${item.invoiceNumber}-${index}`,
		from: item.from,
		to: item.to,
		invoiceNumber: item.invoiceNumber,
		invoiceCreatedDate: item.invoiceCreatedDate,
		invoiceModifiedDate: item.invoiceModifiedDate,
		dueDate: item.dueDate,
		statusName: item.statusName,
		sendCurrencyCode: item.currencyCode,
		customerId: item.customerId,
		invoiceId: item.invoiceId,
		sendAmount: item.sendAmount,
		receiveAmount: item.receiveAmount,
		userId:item.userId,
		currencyCode:item.currencyCode,
		paymentId:item.paymentId,
		paymentType: item.isFreelancer?"B2C":"B2B",
		receiveCurrency: item.receiveCurrency,
		receiveCountryCode: item.receiveCountryCode
	}));
};

export const IndianformatDate = (dateString?: string | null): string => {
    if (!dateString) return "";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "";

    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};